module.exports = __webpack_public_path__ + "static/offering-candles.d329627d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/offering-candles.jpg
// module id = 94
// module chunks = 35783957827783 82680274759079